import { render, staticRenderFns } from "./MoreHorizontalIcon.vue?vue&type=template&id=9e71fb1a&scoped=true&"
import script from "./MoreHorizontalIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MoreHorizontalIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e71fb1a",
  null
  
)

export default component.exports